namespace RioERP.Masters {
    export interface SmsTemplatesForm {
        Status: Serenity.EnumEditor;
        SmsTemplate: Serenity.StringEditor;
        Variables: Serenity.StringEditor;
        VariableCodes: Serenity.StringEditor;
        ApiKey: Serenity.StringEditor;
        Sender: Serenity.StringEditor;
        EntityId: Serenity.StringEditor;
        TemplateId: Serenity.StringEditor;
    }

    export class SmsTemplatesForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.SmsTemplates';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SmsTemplatesForm.init)  {
                SmsTemplatesForm.init = true;

                var s = Serenity;
                var w0 = s.EnumEditor;
                var w1 = s.StringEditor;

                Q.initFormType(SmsTemplatesForm, [
                    'Status', w0,
                    'SmsTemplate', w1,
                    'Variables', w1,
                    'VariableCodes', w1,
                    'ApiKey', w1,
                    'Sender', w1,
                    'EntityId', w1,
                    'TemplateId', w1
                ]);
            }
        }
    }
}
